<!-- Copyright 2025, Common Good Learning Tools LLC -->
<template><div class="k-asset-review-comment-editor">
	<div class="d-flex align-center pa-2">
		<div>{{ editing ? 'Edit' : 'New' }} Comment by {{lcomment.author_name}} ({{lcomment.author_email}})</div>
		<v-spacer/>
		<v-btn :disabled="!comment_changed" class="mr-2" small color="green darken-3" :dark="comment_changed" @click="save_comment">Save<v-icon small class="ml-2">fas fa-save</v-icon></v-btn>
		<v-btn small color="#aaa" class="k-tight-btn" @click="$emit('cancel_comment')">Cancel<v-icon small class="ml-2">fas fa-xmark</v-icon></v-btn>
	</div>
	<div v-if="this.lcomment" class="px-2 pb-2">
		<froala-wrapper v-model="lcomment.text" />
	</div>
</div></template>

<script>
import { mapState } from 'vuex'

export default {
	components: {},

	props: {
		comment: { type: Object, required: true },
		editing: { type: Boolean, default: false},
	},

	data() { return {
		lcomment: false,
	}},

	computed: {
		...mapState(['site_config', 'user_info']),

		comment_changed() { return JSON.stringify(this.comment) != JSON.stringify(this.lcomment) },
	},

	mounted() {
		// generate local copy for editing
		this.lcomment = new Asset_Review_Comment(this.comment)
	},

	methods: {
		save_comment() {
			this.$emit('save_comment', this.lcomment)
		},
	}
}
</script>

<style lang="scss">
// styles for editor are in AssetReviewComment

</style>